<template>
  <div class="overflow-x justify-content-center mt-3">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th >نام مجموعه </th>
                <th >نام سالن</th>
                <th >تاریخ و ساعت</th>
                <th >مبلغ</th>
                <th >موبایل مدیر</th>
                <th >بلیت</th>
                <th ></th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <td>empty</td>
                <th>empty</th>
                <td>
                  <div class="d-flex w-100 mb-1 justify-content-center">
                    {{data.dateConvertedJali}}
                  </div>
                  <div class=" d-flex w-100 justify-content-center">
                    {{data.timeConvertedJali}}
                  </div>
                </td>
                <td>{{data.addCamaPrice}}+</td>
                <td>empty</td>
                <td>{{data.content}}</td>

                <td>
                    <div class="d-flex justify-content-end flex-column">
                            <div class="row w-100 mb-2 justify-content-center">
                              <button @click="detailSalon(data)" type="button" class="btn btn-primary btn-blue btn-sm ml-2 btn-table ">
                                مشخصات سالن
                              </button>
                            </div>
                    </div>
                </td>

              </tr>

            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>


export default {
    name: 'tableContent',
    props: {
      page      : { type: Number, default: 0 },
      tableData : { type: [Object, Array], default: [] },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },
    },

    methods: {
      changePage(page){
        this.$emit('paganationChangePage',page)
      },

      detailSalon(data){
        this.$emit('btnShowModalWallet',data);
      }


    },

}
</script>
